import bg1 from "../Assets/1.jpg";
import bg2 from "../Assets/2.docx.png";
import bg3 from "../Assets/3.png";
import s0 from "../Assets/luke/CP.JPG";
import s1 from "../Assets/folder/EventGuard.png";
import s2 from "../Assets/h2.png";
import s3 from "../Assets/3333.png";
import s4 from "../Assets/folder/LP.JPG";
import s5 from "../Assets/luke/Argus Tactical Team.png";
import s6 from "../Assets/folder/3.jpg";
import s7 from "../Assets/luke/Luke and Mobile.png";
import s8 from "../Assets/folder/argussuv.jpg";
import ab1 from "../Assets/10.png";
import ab2 from "../Assets/11.png";
import ab3 from "../Assets/12.png";
import ab4 from "../Assets/13.png";
import map from "../Assets/9999.png";
import service1 from "../Assets/luke/SecurityGuards.PNG";
import service2 from "../Assets/41.png";
import service3 from "../Assets/42.png";
import service4 from "../Assets/luke/Gatehouse Security Truck Yard.png";
import service5 from "../Assets/luke/Event Security.PNG";
import service6 from "../Assets/luke/Camera Installer.png";
import service7 from "../Assets/luke/Executive Protection.PNG";
import service8 from "../Assets/luke/Concierge at the reception desk.png";
import service9 from "../Assets/luke/Parking Solutions.PNG";
import service10 from "../Assets/folder/secure7.jpg";
import service11 from "../Assets/luke/Fire watch inspection in progress.png";
import service12 from "../Assets/luke/PI.png";
import service13 from "../Assets/luke/MLEO Parking Ticket - Mobile.png";
import service14 from "../Assets/luke/Loss Prevention.png";
import service15 from "../Assets/luke/image028.jpg";
import about1 from '../Assets/about1.png';
import about2 from '../Assets/about2.png';
import location from '../Assets/locaation.png';
import tech1 from '../Assets/tech1.png';
import tech2 from '../Assets/tech2.png';
import tech3 from '../Assets/tech3.png';
import carrer from '../Assets/carrer.png';
import logo from '../Assets/logo.png';
import logo1 from '../Assets/logo_reverse.png';
import cartoon from '../Assets/folder/cartoon.png';
import drone from '../Assets/luke/Construction Drone.PNG';
import s2robot from '../Assets/luke/Modern security system in action.png';
import p2Robot from '../Assets/folder/8.png';

export default {
  carrer,
  bg1,
  bg2,
  bg3,
  s0,
  s1,
  s2,
  s3,
  s4,
  s5,
  s6,
  s7,
  s8,
  ab1,
  ab2,
  ab3,
  ab4,
  map,
  service1,
  service2,
  service3,
  service4,
  service5,
  service6,
  service7,
  service8,
  service9,
  service10,
  service11,
  service12,
  service13,
  service14,
  service15,
  about1,
  about2,
  location,
  tech1,
  tech2,
  tech3,
  logo,
  logo1,
  cartoon,
  drone,
  s2robot,
  p2Robot
};
